var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"product-section"},[_c('h2',{staticClass:"product-section-title"},[_vm._v("Adapter")]),_c('AdapterOwl',{attrs:{"adapters":_vm.adapters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }